<template>
  <v-container
    id="sobre"
    fluid
    class="black py-0 px-0"
  >
    <v-row >
      <v-col 
        cols="12" md="6" 
        class="px-11 pt-12"
      >
        <v-card
          flat
          color="transparent"
          :class="{
            'pl-10': $vuetify.breakpoint.mdAndUp
          }"
        >
          <!-- <v-card-text>{{ text }}</v-card-text> -->
          <h3 class="body-1 font-weight-regular pt-3">
            <span class="barlow grey--text text--lighten-2">sobre nós</span>
          </h3>
          <h2 class="display-1 font-weight-bold pt-0">
            <span class="barlow primary--text" v-text="titulo"></span>
          </h2>
          <!-- <v-divider class="grey lighten-1 my-4" style="width: 50px; border: 2px solid"></v-divider> -->
          <div class="pt-3 grey--text text--lighten-2 font-weight-light">
            <span class="montserrat" v-html="descricao" style="line-height: 1.5"></span>
          </div>
          <div class="pt-2 body-1 primary--text font-weight-light">
            <v-btn
              text
              class="primary--text"
              @click="$vuetify.goTo('#treinamentos')"
            >
              Ver Treinamentos
            </v-btn>
            <v-btn
              text
              class="primary--text"
              @click="$vuetify.goTo('#servicos')"
            >
              Ver Serviços
            </v-btn>
          </div>
        </v-card>
        <div
          class="justify-center align-center center pt-8 pb-6"
        >
          <v-btn
            v-for="(b,i) in acoes" :key="i"
            x-large :outlined="!b.destaque"
            :color="b.cor"
            class="mr-5 mb-3"
            :class="{
              'title': $vuetify.breakpoint.mdAndUp,
            }"
            target="_blank"
            @click="$vuetify.goTo(b.click)"
          >
            <span class="">{{b.rotulo}}</span>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="py-0 my-0">
        <!-- <div style="
          background-color: rgb(253, 19, 50, 0.22);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          z-index: 999
        "></div> -->
        <v-img
          style="position: relative;"
          :src="getImgUrl(imagem)"
          contain
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    imagem: 'sobre.jpg',
    titulo: 'INSTITUTO ALTO IMPACTO',
    // subtitulo: 'É facilitador de grupos e treinador comportamental há mais de 20 anos. Criador do Treinamento Vivencial Luz e Sombra.',
    descricao: '<p>\n\
        Idealizado por Tadeu Belfort Júnior, o Instituto Alto Impacto localiza-se em Fortaleza-CE e é um polo de formação e desenvolvimento contínuo.\n\
      </p>\n\
      <p>\n\
        Trabalha de forma sistêmica o desenvolvimento humano, nas áreas pessoal e profissional, para aqueles que buscam contribuir socialmente, vivendo seus propósitos e realizando a sua missão de vida.\n\
      </p>\n\
      <p>\n\
        O Instituto oferece serviços, treinamentos e formações que conduzem alunos e profissionais à percepção sobre si mesmos, à excelência e a bons resultados.\n\
      </p>',
    acoes: [
      {
        rotulo: 'VER DEPOIMENTOS',
        cor: 'black',
        destaque: false,
        link: '',
        click: '#depoimentos'
      },
    ] 
  }),
  methods: {
    getImgUrl(i) {
        return require('@/assets/img/'+i)
    },
  }
};
</script>